import { Routes, Route, useNavigate, useLocation, Link } from "react-router-dom";
import React, { Suspense, useEffect, useState } from "react";
import { isExpired, decodeToken } from "react-jwt";
import { isLoggedIn } from "../utils/helpers/auth.helpers";
import TermsAndConditions from "../components/layout/login/TermsAndConditions";
import SafeAPDirectory from "../components/layout/directory/ui/SafeAPDirectory";
import PublicProfile from "../components/layout/directory/ui/PublicProfile";
import TwoFactorPage from "../components/layout/login/TwoFactorPage";
import BestPracticeForm from "../components/layout/bestPractices/ui/BestPracticeForm";
import BestPracticeList from "../components/layout/bestPractices/ui/BestPracticeList";
import BestPractice from "../components/layout/bestPractices/ui/BestPractice";
import ProjectInvitePage from "../components/layout/project/ProjectSafeAps/ProjectInvitePage";
import PublicClientQuestionnaireComponent from "../components/layout/publicClientQuestionnaire/PublicClientQuestionnaireComponent";
const ProjectProfile = React.lazy(() =>
    import("../components/layout/project/ProjectProfile")
);
const Evaluation = React.lazy(() =>
    import("../components/layout/project/Evaluation")
);
const Home = React.lazy(() => import("../components/layout/project/Home"));
const Dashboard = React.lazy(() =>
    import("../components/layout/project/Dashboard")
);
const ProjectGrid = React.lazy(() =>
    import("../components/layout/project/ProjectGrid")
);
const CreateProject = React.lazy(() =>
    import("../components/layout/project/CreateProject")
);
const CreateMatrix = React.lazy(() =>
    import("../components/layout/project/CreateMatrix")
);
const SubmitReport = React.lazy(() =>
    import("../components/layout/project/SubmitReport")
);
const EditProject = React.lazy(() =>
    import("../components/layout/project/EditProject")
);
const SpatialMapping = React.lazy(() =>
    import("../components/layout/project/SpatialMapping")
);
const NeighborhoodSurvey = React.lazy(() =>
    import("../components/layout/project/NeighborhoodSurvey")
);
const ProjectProfileAddAPs = React.lazy(() =>
    import("../components/layout/project/ProjectProfileAddAPs")
);
const SafeAPRegistration = React.lazy(() =>
    import("../components/layout/login/SafeAPRegistration")
);
const Login = React.lazy(() => import("../components/layout/login/Login"));
const ForgotPassword = React.lazy(() =>
    import("../components/layout/login/ForgotPassword")
);
const PasswordReset = React.lazy(() =>
    import("../components/layout/login/PasswordReset")
);
const ProjectSearch = React.lazy(() =>
    import("../components/layout/project/ProjectSearch")
);
const Base = React.lazy(() => import("../components/layout/project/Base"));
const ProjectFilter = React.lazy(() =>
    import("../components/layout/project/ProjectFilter")
);
const ProjectClient = React.lazy(() =>
    import("../components/layout/project/ProjectClient")
);
const ViewReport = React.lazy(() =>
    import("../components/layout/project/ViewReport")
);

function RoutesProjects() {
    const Navigate = useNavigate();
    const myDecodedToken = decodeToken(localStorage.getItem("token"));
    const isMyTokenExpired = isExpired(localStorage.getItem("token"));
    const [shouldRedirectLogin, setShouldRedirectLogin] = useState(true)


    const location = useLocation()
    useEffect(() => {
        if (
            !isMyTokenExpired &&
            window.location.href !== `${process.env.REACT_APP_BASE_URL}`
        ) {
            sessionStorage.setItem("id", myDecodedToken.user.id);
            sessionStorage.setItem("name", myDecodedToken.user.fullName.first);
            sessionStorage.setItem("role", myDecodedToken.user.role);
        }
    }, []);

    useEffect(() => {
        
        if (
            location.pathname !== `/` &&
            location.pathname !==`/registration` &&
            location.pathname !==`/forgotPassword` &&
            location.pathname !==`/termsAndConditions`&&
            location.pathname !==`/2faPage`&&
            // location.pathname !==`/createBestPractice`&&
            !location.pathname.includes(`/projectInvite`)&&
            !location.pathname.includes(`/directory`)&&
            !location.pathname.includes(`/passwordReset`)&&
            !location.pathname.includes(`/publicClientQuestionnaire`)

        ) {
            // setShouldRedirectLogin(true)
            // setShouldRedirectLogin(true)
            isLoggedIn(setShouldRedirectLogin)
        }
    });

    // console.log(location.pathname)
    // console.log(isLoggedIn())
    useEffect(() => {
        if (!shouldRedirectLogin) {
            // console.log("Hello")
            console.log("window: ", window.location.href);
            console.log("process", process.env.REACT_APP_BASE_URL);
            Navigate("/");
        }
    }, [shouldRedirectLogin])


    return (
        <Suspense fallback={<>Loading...</>}>
            <Routes>
                <Route exact path="/" element={<Login />} />
                <Route exact path="/error" element={<ErrorPage/>}/>
                {/* <Route exact path="/termsAndConditions" element={<TermsAndConditions/>} /> */}
                <Route exact path="/forgotPassword" element={<ForgotPassword />} />
                <Route exact path="/passwordReset" element={<PasswordReset />} />
                <Route exact path="/registration" element={<SafeAPRegistration />} />
                {/* Uncomment when directory page is ready  */}
                <Route exact path="/directory" element={<SafeAPDirectory/>}/>
                <Route exact path="/directory/:id" element={<PublicProfile/>}/>
                <Route exact path="/2faPage" element={<TwoFactorPage/>}/>

                <Route exact path="/createBestPractice" element={<BestPracticeForm/>}/>
                <Route exact path="/createBestPractice/:id" element={<BestPracticeForm/>}/>

                <Route exact path="/projectInvite/:id" element={<ProjectInvitePage/>}/>

                <Route exact path="/bestPracticeList" element={<BestPracticeList/>}/>
                <Route exact path="/bestPractice/:id" element={<BestPractice/>}/>


                <Route exact path="/publicClientQuestionnaire" element={<PublicClientQuestionnaireComponent />} />
               
                <Route
                    exact
                    path="/projects/search/:term"
                    element={<ProjectSearch />}
                />
                <Route
                    exact
                    path="/projects/filter/:type"
                    element={<ProjectFilter />}
                />
                <Route
                    exact
                    path="/projects/client/:name"
                    element={<ProjectClient />}
                />

                <Route path="/projects" element={<Dashboard />}>
                    <Route
                        path="active"
                        element={<ProjectGrid projectStatus="active" />}
                    />
                    <Route
                        path="completed"
                        element={<ProjectGrid projectStatus="completed" />}
                    />
                </Route>

                <Route path="/projects/new" element={<Dashboard />}>
                    <Route index element={<CreateProject />} />
                </Route>

                {/* <Route
          exact
          path="/projects/profile/:id"
          element={<Base adminView={false} mainContent={<ProjectProfile />} />}
        /> */}

                <Route
                    path="/projects/profile/:id"
                    element={<Dashboard projectType="active" />}
                >
                    <Route index element={<ProjectProfile />} />
                </Route>

                <Route
                    exact
                    path="/projects/profile/:id/evaluation/spatialMapping"
                    element={<SpatialMapping />}
                />
                <Route
                    exact
                    path="/projects/profile/:id/evaluation/neighborhoodSurvey"
                    element={<NeighborhoodSurvey />}
                />
                <Route
                    exact
                    path="/projects/profile/:id/evaluation/:evaluationName"
                    element={<Evaluation />}
                />
                <Route
                    exact
                    path="/matrix/new"
                    element={<Base adminView={false} mainContent={<CreateMatrix />} />}
                />
                <Route
                    exact
                    path="/report/submit"
                    element={<Base adminView={false} mainContent={<SubmitReport />} />}
                />
                <Route
                    exact
                    path="/projects/edit/:id/aps"
                    element={
                        <Base adminView={false} mainContent={<ProjectProfileAddAPs />} />
                    }
                />
                <Route path="/projects/edit/:id" element={<Dashboard />}>
                    <Route index element={<EditProject />} />
                </Route>
                <Route
                    exact
                    path="/projects/profile/:id/view-report"
                    element={<Base adminView={false} mainContent={<ViewReport />} />}
                />
            </Routes>
        </Suspense>
    );
}

const ErrorPage = ()=>{
    return(<div>
        <h1>Error</h1>
        <p>An error has occured, click <Link to="/projects/active">here</Link> to go back to home page </p>
    </div>)
}

export default RoutesProjects;
